// @ts-nocheck


import React from 'react';


import { vehicleTaxRateApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';



export default (selectProps) =>
<AutocompleteSelect
  fetch={async (params) => {
    return await vehicleTaxRateApi.fetch({
      ...params
    });
  }}
  fetchSingle={vehicleTaxRateApi.get}
  notFoundText="Объекты налогообложения не найдены"
  placeholder="Выберите объект налогообложения"
  renderOption={(vehicleTaxRate, Option) =>
  <Option
    key={vehicleTaxRate.id}
    value={vehicleTaxRate.id}
    vehicleTaxRate={vehicleTaxRate}>

        {vehicleTaxRate.name}
      </Option>
  }
  {...selectProps} />;
